import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "paramsStep"
};
const _hoisted_2 = {
  class: "flexLine"
};
const _hoisted_3 = {
  class: "durationSelection"
};
const _hoisted_4 = {
  class: "paramsStepTitle"
};
const _hoisted_5 = {
  class: "languageSelection"
};
const _hoisted_6 = {
  class: "paramsStepTitle"
};
const _hoisted_7 = {
  class: "flexLine"
};
const _hoisted_8 = {
  class: "allowReorder"
};
const _hoisted_9 = {
  class: "paramsStepTitle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_segmented = _resolveComponent("el-segmented");
  const _component_w_select = _resolveComponent("w-select");
  const _component_w_checkbox = _resolveComponent("w-checkbox");
  const _component_w_input = _resolveComponent("w-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.duration')), 1), _createVNode(_component_el_segmented, {
    modelValue: _ctx.durationSelected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.durationSelected = $event),
    options: _ctx.listOfDuration,
    onChange: _ctx.onDurationSelected
  }, null, 8, ["modelValue", "options", "onChange"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.language')), 1), _createVNode(_component_w_select, {
    placeholder: _ctx.$t('aiSpeachGenerator.options.languages.placeholder'),
    options: _ctx.listOfLanguage,
    value: _ctx.language,
    onChange: _ctx.onLanguageChange
  }, null, 8, ["placeholder", "options", "value", "onChange"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_w_checkbox, {
    class: "checkBoxReorder",
    "model-value": _ctx.allowReorder,
    "onUpdate:modelValue": _ctx.onAllowReorderChange
  }, null, 8, ["model-value", "onUpdate:modelValue"]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.allowReorder')), 1)])]), _createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('aiSpeachGenerator.options.specificInstruction')), 1), _createVNode(_component_w_input, {
    class: "specificInstructionTextArea",
    value: _ctx.specificPrompt,
    type: "textarea",
    onChange: _ctx.onSpecificPromptChange,
    placeholder: _ctx.$t('aiSpeachGenerator.options.instructionsPlaceholder')
  }, null, 8, ["value", "onChange", "placeholder"])])]);
}